import React from 'react'
import { Container } from './ui'

/**
 * Minimal footer. Editorial-look tools shouldn't shout at the bottom of
 * the page — a single muted line of provenance is enough.
 */
const Footer: React.FC = () => {
  return (
    <footer className="border-t border-rule bg-paper-200 mt-12 print:hidden">
      <Container>
        <div className="py-4 flex flex-col sm:flex-row gap-2 sm:gap-6 justify-between text-xs text-ink-500">
          <span>
            Data hentes fra CVR-registret (Erhvervsstyrelsen). Værktøjet er
            kun til redaktionel brug.
          </span>
          <span>© {new Date().getFullYear()}</span>
        </div>
      </Container>
    </footer>
  )
}

export default Footer
